import ApprovalAllowanceApplicationPage from './ApprovalAllowanceApplicationPage';

export default ApprovalAllowanceApplicationPage;
